import styled from "styled-components";
import { THEME } from "THEME";

export const SideBenefits = styled.div`
  width: 100%;
`;

export const SideBenefitsTitle = styled.h2`
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  margin-bottom: 30px;
  text-align: center;
  @media (min-width: 960px) {
    font-size: 42px;
    line-height: 48px;
    margin-bottom: 40px;
  }
`;

export const SideBenefitsItems = styled.div``;

export const SideBenefitsItemArrow = styled.div`
  width: 16px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #87888d;
  position: absolute;
  right: 16px;
  top: calc(50% - 8px);
  transform: rotate(0);
  transition: color ${THEME.TRANSITION}, transform ${THEME.TRANSITION};
  @media (min-width: 960px) {
    width: 24px;
    min-width: 24px;
    height: 24px;
    top: calc(50% - 12px);
    right: 30px;
  }
`;

export const SideBenefitsItem = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  .is-open {
    ${SideBenefitsItemArrow} {
      transform: rotate(180deg);
      color: #acacaf;
    }
  }

  @media (min-width: 960px) {
    margin-bottom: 16px;
      cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const SideBenefitsItemTop = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px 16px;
  background-color: #F4F1E9;
  border-radius: 90px;
  @media (min-width: 960px) {
    padding: 16px;
  }
`;

export const SideBenefitsItemText = styled.div`
  padding: 12px 16px;
  font-size: 14px;
  line-height: 20px;
  color: #3F5366;

  p {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (min-width: 960px) {
    font-size: 20px;
    line-height: 28px;
    padding: 16px 70px 10px;
  }
`;

export const SideBenefitsItemImageWrap = styled.div`
  width: 44px;
  min-width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
`;

export const SideBenefitsItemImage = styled.img`
  width: 100%;
  height: auto;
`;

export const SideBenefitsItemTitle = styled.p`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin-right: 20px;
  @media (min-width: 960px) {
    font-size: 24px;
    line-height: 28px;
  }
`;
